module.exports = __webpack_public_path__ + "img/file-image-fill.a24bfe3e.svg";